<template>
    <ff-loading v-if="loading.deleting" message="Deleting Application..." />
    <ff-loading v-else-if="loading.suspend" message="Suspending Application..." />
    <main v-else-if="!application?.id">
        <ff-loading message="Loading Application..." />
    </main>
    <main v-else class="ff-with-status-header flex flex-col h-full w-full overflow-auto" data-el="application-page">
        <ConfirmApplicationDeleteDialog ref="confirmApplicationDeleteDialog" @confirm="deleteApplication" />
        <ConfirmInstanceDeleteDialog ref="confirmInstanceDeleteDialog" @confirm="onInstanceDeleted" />
        <ff-page-header :title="application.name" :tabs="navigation">
            <template #breadcrumbs>
                <ff-nav-breadcrumb v-if="team" :to="{name: 'Applications', params: {team_slug: team.slug}}">Applications</ff-nav-breadcrumb>
            </template>
        </ff-page-header>
        <div class="px-3 py-3 md:px-6 md:py-6 flex-1 flex flex-col h-full overflow-auto">
            <router-view
                :application="application"
                :instances="instancesArray"
                :is-visiting-admin="isVisitingAdmin"
                @application-updated="updateApplication"
                @application-delete="showConfirmDeleteApplicationDialog"
                @instance-start="instanceStart"
                @instance-restart="instanceRestart"
                @instance-suspend="instanceShowConfirmSuspend"
                @instance-delete="instanceShowConfirmDelete"
            />

            <InstanceStatusPolling v-for="instance in instancesArray" :key="instance.id" :instance="instance" @instance-updated="instanceUpdated" />
        </div>
    </main>
</template>

<script>
// import { ChipIcon, ClockIcon, CogIcon, TerminalIcon, ViewListIcon } from '@heroicons/vue/solid'

import { mapState } from 'vuex'

import InstanceStatusPolling from '../../components/InstanceStatusPolling.vue'
// import PipelinesIcon from '../../components/icons/Pipelines.js'
// import ProjectsIcon from '../../components/icons/Projects.js'
import usePermissions from '../../composables/Permissions.js'

import applicationMixin from '../../mixins/Application.js'
import instanceActionsMixin from '../../mixins/InstanceActions.js'

import ConfirmInstanceDeleteDialog from '../instance/Settings/dialogs/ConfirmInstanceDeleteDialog.vue'

import ConfirmApplicationDeleteDialog from './Settings/dialogs/ConfirmApplicationDeleteDialog.vue'

export default {
    name: 'ApplicationPage',
    components: {
        ConfirmApplicationDeleteDialog,
        ConfirmInstanceDeleteDialog,
        InstanceStatusPolling
    },
    mixins: [applicationMixin, instanceActionsMixin],
    setup () {
        const { hasPermission, isVisitingAdmin } = usePermissions()

        return { hasPermission, isVisitingAdmin }
    },
    computed: {
        ...mapState('account', ['features', 'team']),
        navigation () {
            const routes = [
                {
                    label: 'Hosted Instances',
                    to: { name: 'ApplicationInstances' },
                    tag: 'application-overview'
                    // icon: ProjectsIcon
                },
                {
                    label: 'Remote Instances',
                    to: { name: 'ApplicationDevices' },
                    tag: 'application-devices-overview'
                    // icon: ChipIcon
                },
                {
                    label: 'Device Groups',
                    to: { name: 'ApplicationDeviceGroups' },
                    tag: 'application-devices-groups-overview',
                    // icon: ChipIcon,
                    hidden: !this.hasPermission('application:device-group:list', { application: this.application }),
                    featureUnavailable: !this.features?.deviceGroups
                },
                {
                    label: 'Snapshots',
                    to: { name: 'ApplicationSnapshots' },
                    tag: 'application-snapshots'
                    // icon: ClockIcon
                },
                {
                    label: 'Pipelines',
                    to: { name: 'ApplicationPipelines' },
                    tag: 'application-pipelines',
                    // icon: PipelinesIcon,
                    hidden: !this.hasPermission('application:pipeline:list', { application: this.application }),
                    featureUnavailable: !this.features?.['devops-pipelines']
                },
                {
                    label: 'Logs',
                    to: { name: 'application-logs' },
                    tag: 'application-logs'
                    // icon: TerminalIcon
                },
                {
                    label: 'Audit Log',
                    to: { name: 'application-activity' },
                    tag: 'application-activity',
                    // icon: ViewListIcon,
                    hidden: !this.hasPermission('application:audit-log', { application: this.application })
                },
                {
                    label: 'Dependencies',
                    to: { name: 'application-dependencies' },
                    tag: 'application-dependencies',
                    // icon: CogIcon,
                    hidden: !this.hasPermission('application:bom', { application: this.application })
                },
                {
                    label: 'Settings',
                    to: { name: 'application-settings' },
                    tag: 'application-settings'
                    // icon: CogIcon
                }
            ]

            return routes
        }
    },
    watch: {
        '$route.params': {
            handler: 'updateApplication',
            immediate: true
        }
    }
}
</script>
